module.exports = __webpack_public_path__ + "files/SPIADI2026 - DIA INF ADI.c2b44e0454254dfc1acf0845d8b39350.xlsx";